export default __webpack_public_path__ + "static/images/b5adad9157e2e8263913d1c19d1db2be.png";